import { Action, createReducer, on } from '@ngrx/store';

import { ProductRelatedPartsState } from './product-related-parts-state.type';
import { ProductRelatedPartsActions } from './product-related-parts.actions';
import {
  productRelatedPartsReplacementMapper,
  productRelatedPartsTabsMapper
} from '@app-modules/product/shared/store/product-related-parts/product-related-parts.mappers';

const initialState: ProductRelatedPartsState = {
  activeTab: null,
  categories: [],
  currentPage: 0,
  tabs: []
};

const reducer = createReducer(
  initialState,
  on(ProductRelatedPartsActions.loadConfigSuccess, (state, { relatedParts }): ProductRelatedPartsState => {
    const tabs = productRelatedPartsTabsMapper(relatedParts);
    const replacement = productRelatedPartsReplacementMapper(relatedParts);
    return { ...state, tabs, activeTab: tabs[0]?.code ?? null, replacement, currentPage: 0 };
  }),
  on(ProductRelatedPartsActions.setActiveTab, (state, { code }) => ({ ...state, activeTab: code, currentPage: 0 })),
  on(ProductRelatedPartsActions.changeCurrentPage, (state, { currentPage }) => ({ ...state, currentPage }))
);

export const productRelatedPartsReducers = (
  state: ProductRelatedPartsState,
  action: Action
): ProductRelatedPartsState => reducer(state, action);
